export function getPublisherToken() {
  const searchParams = new URLSearchParams(window.location.search);
  const publisherToken = searchParams.get('publisher-token') || '';
  return publisherToken;
}
